import { useState } from "react";

export const SessionContextPanelType = {
  AGENT: "agent",
  DATASET: "dataset",
} as const;
export type SessionContextPanelType =
  (typeof SessionContextPanelType)[keyof typeof SessionContextPanelType];

const DEFAULT_VIEW = "overview";

interface SessionContextPanelState {
  type: SessionContextPanelType;
  id: string;
  // Which sub-view is showing within the entity's detail (e.g. "overview",
  // "skills"). Always defined once a panel is open — defaults to "overview".
  view: string;
}

interface UseSessionContextPanelResult {
  // null means the sidebar shows its table-of-contents (home) view.
  panel: SessionContextPanelState | null;
  openPanel: (type: SessionContextPanelType, id: string) => void;
  setView: (view: string) => void;
  goHome: () => void;
}

// Backs the session context sidebar's TOC/detail state and which
// dataset/agent + sub-view it's showing.
export function useSessionContextPanel(): UseSessionContextPanelResult {
  const [panel, setPanel] = useState<SessionContextPanelState | null>(null);

  const openPanel = (type: SessionContextPanelType, id: string) => {
    setPanel({ type, id, view: DEFAULT_VIEW });
  };

  const setView = (view: string) => {
    setPanel((prev) => (prev ? { ...prev, view } : prev));
  };

  const goHome = () => {
    setPanel(null);
  };

  return { panel, openPanel, setView, goHome };
}
